module.exports = __webpack_public_path__ + "media/PAG65-05.04c5b952.mp3";